(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-card-add"] && !Shopify.designMode) return;
  try {
    if (!window.hsCardAddBound) {
    window.hsCardAddBound = true;

    document.addEventListener('click', function (event) {
      var go = event.target.closest('[data-hs-card-go]');
      if (go) {
        event.preventDefault();
        window.location.href = go.getAttribute('data-hs-card-go');
        return;
      }

      var chip = event.target.closest('[data-hs-card-variant]');
      if (chip) {
        event.preventDefault();
        if (chip.disabled) return;
        var box = chip.closest('[data-hs-card-add-box]');
        box.querySelectorAll('[data-hs-card-variant]').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-selected');
        chip.setAttribute('aria-pressed', 'true');
        var addBtn = box.querySelector('[data-hs-card-add]');
        if (addBtn) addBtn.setAttribute('data-hs-card-add', chip.getAttribute('data-hs-card-variant'));
        return;
      }

      var btn = event.target.closest('[data-hs-card-add]');
      if (!btn) return;
      event.preventDefault();
      if (btn.disabled) return;
      var id = parseInt(btn.getAttribute('data-hs-card-add'), 10);
      if (!id) return;

      var label = btn.querySelector('span');
      var original = label ? label.textContent : '';
      var reset = function (text, delay) {
        setTimeout(function () {
          btn.disabled = false;
          if (label) label.textContent = text || original;
        }, delay || 0);
      };

      btn.disabled = true;
      if (label) label.textContent = 'Adding';

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble'
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (state) {
          var drawer = document.querySelector('cart-drawer');
          if (state && state.sections && drawer) {
            drawer.renderContents(state);
            reset(original, 400);
          } else if (state && state.status) {
            if (label) label.textContent = 'Unavailable';
            reset(original, 2000);
          } else {
            window.location.href = window.routes.cart_url;
          }
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
          reset(original, 2000);
        });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-card-media"] && !Shopify.designMode) return;
  try {
    if (!window.hsCardMediaBound) {
    window.hsCardMediaBound = true;

    // Scroll events do not bubble, so listen in the capture phase to keep the dots in step.
    document.addEventListener('scroll', function (event) {
      var track = event.target;
      if (!track || !track.matches || !track.matches('[data-hs-card-track]')) return;
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width);
      var media = track.closest('[data-hs-card-media]');
      if (!media) return;
      media.querySelectorAll('[data-hs-card-dot]').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }, true);

    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-hs-card-dot], [data-hs-card-arrow]');
      if (!control) return;
      event.preventDefault();
      var media = control.closest('[data-hs-card-media]');
      var track = media && media.querySelector('[data-hs-card-track]');
      if (!track) return;
      var width = track.clientWidth || 1;
      var current = Math.round(track.scrollLeft / width);
      var target = control.hasAttribute('data-hs-card-dot')
        ? parseInt(control.getAttribute('data-hs-card-dot'), 10)
        : current + parseInt(control.getAttribute('data-hs-card-arrow'), 10);
      target = Math.max(0, Math.min(track.children.length - 1, target));
      track.scrollTo({ left: target * width, behavior: 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
